import { memo } from "react";
import {
  MenuItem,
  Menu,
} from "@mui/material";
import { useMainContext } from "../../../../../../context/useMainContext";

const CheckFiltersMenu = ({ checkAnchorEl, setCheckAnchorEl, handleCloseDots }) => {
  const {
    checkStatusFilter,
    setCheckStatusFilter,
  } = useMainContext();

  const openCheckPopover = Boolean(checkAnchorEl);

  const checkFilterOptions = [
    { value: "", label: "Show All" },
    { value: "free_only", label: "Only Free Check Completed" },
    { value: "paid_only", label: "Only Paid Check Completed" },
    { value: "both", label: "Both Checks Completed" },
    { value: "none", label: "No Checks Completed" },
  ];

  const handleClose = () => {
    setCheckAnchorEl(null);
    handleCloseDots();
  };

  const handleFilterSelect = (value) => {
    setCheckStatusFilter(value);
    setCheckAnchorEl(null);
    handleCloseDots();
  };

  return (
    <Menu
      open={openCheckPopover}
      anchorEl={checkAnchorEl}
      onClose={handleClose}
      anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      transformOrigin={{ vertical: "top", horizontal: "right" }}
    >
      {checkFilterOptions.map(({ value, label }) => (
        <MenuItem
          key={value}
          onClick={() => handleFilterSelect(value)}
          disabled={checkStatusFilter === value}
        >
          {label}
        </MenuItem>
      ))}
    </Menu>
  );
};

export default memo(CheckFiltersMenu);
